import type { WorkItemKind } from './types';

/**
 * `WorkItem.id` is namespaced by kind. The merge de-dupes across sources with a
 * first-wins map, so a bare id would let a document and a request that happen to
 * share one collide and silently drop whichever arrived second — whatever its
 * deadline. The intra-document overlap that genuinely needs merging is settled
 * upstream, inside the documents source, so a cross-kind clash is a key bug and
 * not a precedence question.
 */
export function workItemId(kind: WorkItemKind, sourceId: string | number) {
  return `${kind}:${sourceId}`;
}

/** The backend's own id, for the one place that has to send it back. */
export function sourceIdOf(id: string) {
  const separator = id.indexOf(':');
  return separator === -1 ? id : id.slice(separator + 1);
}
